import React from 'react';
import { Link } from 'react-router-dom';
import { getFigurineImageSrc } from '../utils/figurineMedia';

export function BrandLogo({ className = '', compact = false }) {
  return (
    <Link to="/" className={`nfig-logo ${compact ? 'nfig-logo--compact' : ''} ${className}`} aria-label="NFig home">
      <img src="/logo.png" alt="NFig" />
    </Link>
  );
}

export function SectionHeading({ eyebrow, title, description, action }) {
  return (
    <div className="nfig-section-heading">
      <div>
        {eyebrow && <p className="nfig-eyebrow">{eyebrow}</p>}
        <h2>{title}</h2>
        {description && <p className="nfig-section-description">{description}</p>}
      </div>
      {action && <div className="nfig-section-action">{action}</div>}
    </div>
  );
}

export function RarityBadge({ rating }) {
  return (
    <span className="nfig-rarity" aria-label={`${rating} star rarity`}>
      <span aria-hidden="true">★</span> {rating === 6 ? 5 : rating}
    </span>
  );
}

export function FigureCard({ figure, onClick, compact = false }) {
  const interactiveProps = onClick
    ? {
        role: 'button',
        tabIndex: 0,
        onClick,
        onKeyDown: (event) => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick();
          }
        },
      }
    : {};

  return (
    <article
      className={`nfig-figure-card group ${compact ? 'nfig-figure-card--compact' : ''} ${onClick ? 'cursor-pointer' : ''}`}
      {...interactiveProps}
    >
      <div className="nfig-figure-image">
        <img src={getFigurineImageSrc(figure)} alt={figure.name} loading="lazy" />
        {figure.stock === 0 && <span className="nfig-stock-badge">Pre-order</span>}
      </div>
      <div className="nfig-figure-copy">
        <p className="nfig-figure-series">{figure.series}</p>
        <h3>{figure.name}</h3>
        <div className="nfig-figure-meta">
          {figure.rating != null && <RarityBadge rating={figure.rating} />}
          <span className="nfig-price">₪{figure.value}</span>
        </div>
      </div>
    </article>
  );
}
